import { Link } from "react-router-dom";
import styles from "./PublicNavbar.module.css";

function PublicNavbar() {
  return (
    <nav className={`${styles.navBar} navbar navbar-expand-lg`}>
      <div className={`${styles.homeNavDiv} container w-50 py-3`}>
        <Link className="nav-brand" to="/" id="logo-nav">
          <img
            src="/DataRevival_REV_RGB.svg"
            alt="PSDI Icon"
            className="img-fluid"
            style={{ width: "200px", height: "auto" }}
          />
        </Link>

        <button
          className={`${styles.navToggler} navbar-toggler`}
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <i className="fas fa-bars" style={{ color: "white" }}></i>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <Link
                className={`${styles.navLink} nav-link`}
                to="/howMalvoxWorks"
              >
                How it works
              </Link>
            </li>

            <li className="nav-item">
              <a
                className={`${styles.navLink} nav-link`}
                href="https://medium.com/@malvox"
                target="_blank"
                rel="noopener noreferrer"
              >
                About us
              </a>
            </li>

            <li className="nav-item">
              <Link className={`${styles.navLink} nav-link`} to="/contact">
                Contact
              </Link>
            </li>
          </ul>
          <ul className="navbar-nav mb-2 mb-lg-0">
            <li className="nav-item">
              <Link className={`${styles.navLink} nav-link`} to="/login">
                Sign in
              </Link>
            </li>
          </ul>
          <ul className="navbar-nav mb-2 mb-lg-0">
            <li className="nav-item">
              <Link
                className={`${styles.primaryButton} btn btn-sm ms-3`}
                to="/signup"
              >
                Get started
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default PublicNavbar;
